import React, { Component } from "react";
import Icons from '../../icon';
import { convertFormattedDateToDate, isDecimal, isIsoDate, isValidFormattedDate } from '../../../utils/helpers.utils';
import "./table-component.css";
import Translation from '../../common/translation/translation.component';
import { NoSubscription } from '../../../components/external/dashboard/no-subscription/no-subscription.component';
import { TABLE_NO_LINK_DATA, TABLE_PAGINATION_KEY, TYPE_FUNCTION } from "../../../constants/external-constants";
import FormatDate from "../date/format-date.component";

export class TbodyExhibit1 extends Component {
  constructor(props) {
    super(props);
    this.checkStatus();
  }

  componentDidUpdate() {
    this.checkStatus();
  }

  componentDidMount() {
    window.addEventListener("load", this.checkStatus);
    this.checkStatus();
  }

  componentWillUnmount() {
    window.removeEventListener("load", this.checkStatus);
    this.checkStatus();
  }

  checkStatus() {
    const tableWithCheckStatus = [
        TABLE_PAGINATION_KEY.requestAllRequest,
        TABLE_PAGINATION_KEY.requestMyRequest,
        TABLE_PAGINATION_KEY.requestApprovalRequest,
        TABLE_PAGINATION_KEY.orderOrder,
        TABLE_PAGINATION_KEY.outputRecord
      ];

    if (!tableWithCheckStatus.includes(this.props.tablePaginationKey)) {
        return;
    }

    const visibleColumns = this.getColumns().filter(c => !c.hidden);
    
    const hasStatusColumn = visibleColumns.some(col => col.name && col.name.toLowerCase().includes("status"));
    if (!hasStatusColumn) {
        return;
    }

    const statusList = document.querySelectorAll(".col-text-overflow");
      if (!this.props.hideStatusIcon) {
          for (var i = 0; statusList.length > i; i++) {
            
              const currentCell = statusList[i];
              const cellIndex = Array.from(currentCell.parentNode.children).indexOf(currentCell);

              const headerForThisCell = visibleColumns[cellIndex];

            if (headerForThisCell && headerForThisCell.name.toLowerCase().includes('status')) {
                statusList[i].classList.remove(
                  "circle-yellow-icon",
                  "circle-red-icon",
                  "circle-green-icon",
                  "circle-blue-icon"
                                    );
              if (
                  statusList[i].innerText.toLowerCase().includes("Waiting".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-yellow-icon");
              } else if (
                  statusList[i].innerText.toLowerCase().includes("In Progress".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-yellow-icon");
              } else if (
                  statusList[i].innerText.toLowerCase().includes("cancelled".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-red-icon");
              } else if (
                  statusList[i].innerText.toLowerCase().includes("completed".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-green-icon");
              } else if (
                  statusList[i].innerText.toLowerCase().includes("approved".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-blue-icon");
              } else if (
                  statusList[i].innerText.toLowerCase().includes("open".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-yellow-icon");
              } else if (
                  statusList[i].innerText.toLowerCase().includes("rejected".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-red-icon");
              } else if (
                  statusList[i].innerText.toLowerCase().includes("failed".toLowerCase())
              ) {
                  statusList[i].classList.add("circle-red-icon");
              }

            }
          }
      }

  }

    renderTableRow = () => {
      const { uniqueKeyProp } = this.props;
      var key = 0;
      var columns = this.props.columns[0] ? this.props.columns[0] : this.props.columns;
      if (this.props.pageList.length > 0) {
          return this.props.pageList.map((x) => {
              return (
                  <tr key={`${uniqueKeyProp ? uniqueKeyProp : "tr-" + Object.values(x)[0] + key++}`}>
                      {this.renderTableData(x)}
                  </tr>
              );
          });
      }
      else if (this.props.isLoading) {
          return (
              <tr key={"tr-0"}>
                  <td colSpan={Object.values(columns).filter(f => !f.hidden).length}>
                      <h4 className="table-no-results text-align-center">
                          <NoSubscription title={<Translation translationKey="loading" />} />
                      </h4>
                  </td>
              </tr>
          );
      }
      else {
          return (
              <tr key={"tr-0"}>
                  <td colSpan={Object.values(columns).filter(f => !f.hidden).length}>
                      <h4 className="table-no-results text-align-center">
                          {
                              !this.props.noDataAvailable ?
                                  <Translation translationKey="no_results_found" /> :
                                  <Translation translationKey="no_data_available" />                                                
                          }
                      </h4>
                  </td>
              </tr>
          );
      }
  };
 
  enableUpdate(){
    if (typeof this.props.enableUpdate === TYPE_FUNCTION) {
        this.props.enableUpdate(true)
    }
    if (typeof this.props.toggleDropdown === TYPE_FUNCTION) {          
        this.props.toggleDropdown()
    }
    if (typeof this.props.showDetails === TYPE_FUNCTION) {          
        this.props.showDetails(false);
    }       
}

handleRowClick = (type,value, isLink) => (event) => {
  // The isLink prop can be ignored if the callback action does not include multiple behaviors.
  if (typeof this.props.rowClickAction === TYPE_FUNCTION) {          
    this.props.rowClickAction(type,value, isLink);
  }  

  this.enableUpdate();
}

renderTableDataValue(item, column) {
    const itemValue = this.getItemValue(item, column);
    if (this.isDateColumn(column, itemValue)) {
        return this.renderDate(itemValue, column);
    } else {
        return this.renderRegularOrIconCell(item, column, itemValue);
    }
}

getItemValue(item, column) {
    return column.shortName ? item[column.shortName] : item[column.propName];
}

isDateColumn(column, itemValue) {
    return (column.isDateTime && isIsoDate(itemValue)) || isValidFormattedDate(itemValue);
}

renderDate(itemValue, column) {
    let dateValue = convertFormattedDateToDate(itemValue, column.formats["date"]);
    if (dateValue.toString().toLowerCase() === 'invalid date') {
        dateValue = new Date(itemValue);
    }
    return <FormatDate date={dateValue} />;
}

renderRegularOrIconCell(item, column, itemValue) {
    const isWarningColumn = column.propName === this.props.warningIconConfig?.columnName;
    const shouldShowWarning = item[this.props.warningIconConfig?.warningCondition];
    const quotedValue = /("[\d,]+")/g;
    let formattedValue = itemValue;

    if (isWarningColumn && shouldShowWarning) {
        return (
            <div className="td-with-icon">
                <span>{formattedValue}</span>
                {this.getWarningIcon(item)}
            </div>
        );
    } else if(typeof itemValue === 'string' && quotedValue.test(itemValue))
    {
        const parts = itemValue.split(/(".*?")/g).map((part, index) => {
            if (/^"[\d,]+"$/.test(part)) {
                return <span key={index} className="fw-semibold">{part}</span>;
            }
            return <span key={index}>{part}</span>;
        });
    
        return <>{parts}</>;
    }
    
    else {
        return formattedValue;
    }
}


  getProp(columns, name) {
    return Object.entries(columns)
      .filter((x) => {
        return x[1].name === name;
      })
      .map((x) => x[0])[0];
  }


getWarningIcon = (item) =>{
    return (
        <div className="table-icon__warning">
            <Icons
                customClassName="icon-warning__content"
                name="circle-exlamation-warning"
                size="15px"
                containerClass="icon-warning__container"
            />
            <div className="table-icon__tooltip">
                <span>
                    {
                        this.props.warningIconConfig?.tooltip
                    }
                </span>
            </div>
        </div>
    )
}

getColumns = () => {   
    return this.props.columns[0] ? Object.values(this.props.columns[0]) : Object.values(this.props.columns);    
}

getColumnProperties = (column, item, index) => {
    const columnConfig = this.props.columnFormatRendering ? this.props.columnFormatRendering[column.propName] : null;
    const dataNotFound = item[column.propName] == null || item[column.propName] === '' || TABLE_NO_LINK_DATA.includes(item[column.propName]);
    const renderAsLink = columnConfig && dataNotFound && columnConfig.createLinkText & columnConfig.isLink ? true : column.isLink;
    const className = (index === 0 || column.isLink && renderAsLink) ? 'col-text-overflow list-item-link' : 'col-text-overflow';
    const clickHandler = ((this.props.haveLink && index === 0 || column.isLink)) ? this.handleRowClick(item, column?.isLink) : null;

    return { dataNotFound, renderAsLink, className, clickHandler };
}

getTdClassName = (item,column, dataNotFound, renderAsLink, className) => {
    const columnConfig = this.props.columnFormatRendering ? this.props.columnFormatRendering[column.propName] : null;
    const isStatusInvalid = item.AuditRulesResultsStatusName === 'Invalid';
    return `${((this.props.haveLink || column.isLink) && !dataNotFound) ? className : isDecimal(this.renderTableDataValue(item, column)) < 0 ? "table-td-right" : "col-text-overflow"} ${((columnConfig?.createLinkText && dataNotFound) && !isStatusInvalid) ? "plus-icon" : ""}`;
}

getClickHandler = (column, item, dataNotFound, renderAsLink, clickHandler) => {
    if (this.props.columnFormatRendering) {
        return renderAsLink ? this.handleRowClick(column.propName, item, column?.isLink) : this.handleRowClick(column.propName, item, column?.isLink);
    }
    return (this.props.haveLink || column.isLink) ? clickHandler : this.handleRowClick(item, column?.isLink);
}

getTableCellContent = (item, column, dataNotFound) => {
    const columnConfig = this.props.columnFormatRendering ? this.props.columnFormatRendering[column.propName] : null;
    const isStatusInvalid = item.AuditRulesResultsStatusName === 'Invalid';
    //if (dataNotFound && !item.BilledCircuitID && columnConfig) return null;

    if (dataNotFound && columnConfig) {
        if (columnConfig.noDataText) return columnConfig.noDataText;
        if (columnConfig.createLinkText) return <span className="link-text">{!isStatusInvalid ? columnConfig.createLinkText : ""}</span>;
    }

    return this.renderTableDataValue(item, column)
}

renderTableData = (item) => {
    return this.getColumns().map((c, originalIndex) => {
     
      const index = originalIndex === 0 ? originalIndex : originalIndex - 1;
  
      if (c.hidden) return null;
  
      const { dataNotFound, renderAsLink, className, clickHandler } = this.getColumnProperties(c, item, index);
  
      return (
        <td
          className={this.getTdClassName(item, c, dataNotFound, renderAsLink, className)}
          key={`td-${c.name}-${Object.keys(c)[0]}`}
          hidden={c.hidden}
          onClick={this.getClickHandler(c, item, dataNotFound, renderAsLink, clickHandler)}
        >
          {this.getTableCellContent(item, c, dataNotFound)}
        </td>
      );
    });
  };
  

  render() {
    return <tbody>{this.renderTableRow()}</tbody>;
  }
}
